function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "linkedin",
  transform: "translate(-758 -55)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M54.057,24.937C53.745,10.782,43.622,0,27.184,0S0,10.782,0,24.937C0,38.8,10.429,49.892,26.561,49.892h.307C43.622,49.892,54.057,38.8,54.057,24.937ZM50.892,69.6H2.841V213.971H50.892Zm117.964-3.393c31.619,0,55.325,20.639,55.325,64.984l0,82.779H176.13v-77.24c0-19.4-6.953-32.64-24.348-32.64-13.275,0-21.182,8.925-24.654,17.545-1.271,3.09-1.582,7.393-1.582,11.708v80.63H77.489s.633-130.825,0-144.372h48.057V90.049C131.923,80.218,143.345,66.206,168.856,66.206Z",
  transform: "translate(758 55)",
  fill: "#fff",
  fillRule: "evenodd"
}));

function SvgLinkedinLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224.181 213.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLight);
export default __webpack_public_path__ + "static/media/linkedinLight.983ac90d.svg";
export { ForwardRef as ReactComponent };